/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Launch_Latest_DescInputs */

const en_directory_launch_latest_desc = /** @type {(inputs: Directory_Launch_Latest_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recently added AI tools worth exploring.`)
};

const zh_directory_launch_latest_desc = /** @type {(inputs: Directory_Launch_Latest_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`近期收录、值得探索的 AI 工具。`)
};

/**
* | output |
* | --- |
* | "Recently added AI tools worth exploring." |
*
* @param {Directory_Launch_Latest_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_launch_latest_desc = /** @type {((inputs?: Directory_Launch_Latest_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Launch_Latest_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_launch_latest_desc(inputs)
	return zh_directory_launch_latest_desc(inputs)
});
export { directory_launch_latest_desc as "directory.launch.latest_desc" }